<template>
	<div class="promotion-container" :class="{ 'pc-expanded': isExpanded}">
		<div class="promotion-btn-container">
			<div class="promotion-btn-wrap">
				<button class="theme-btn promotion-btn" @click="togglePromotionContent">
					<span class="promotion-btn-text">
						{{isExpanded?'Hide ': 'Show '}} Promotions
					</span>
				</button>

				<!-- <router-link :to="'/promotion'" class="theme-btn promotion-btn">
                <span class="promotion-btn-text">
                 {{isExpanded?'Hide ': 'Show '}} Promotions
                 </span></router-link> -->
			</div>
		</div>
		<!-- <transition name="fade" appear> -->
		<vue-slide-up-down :active="isExpanded">
			<div class="promotion-content">
				<div class="container">
					<slick ref="p-slick" :options="promotionSlickOptions">
						<div class="promotion-item" v-for="item in items" :key="item.Id">
							<img :src="'api/image/promotion/'+item.Id" :alt="item.Title" :title="item.Title" @click="onPromotionImageClick(item.Id)" />
						</div>
						<!-- <div class="promotion-item">
                          <img src="/static/img/partners/logo02.png" alt="">
                      </div>
                      <div class="promotion-item">
                          <img src="/static/img/partners/logo03.png" alt="">
                      </div>
                      <div class="promotion-item">
                        <img src="/static/img/partners/logo05.png" alt="">
                      </div> -->
					</slick>
				</div>
			</div>
		</vue-slide-up-down>
	</div>
</template>
<script>
	import Slick from "vue-slick";
	import VueSlideUpDown from "../utilities/slide-up-down.js";
	export default {
		components: {
			VueSlideUpDown,
			Slick
		},
		props: {
			items: {
				type: Array,
				default: []
			}
		},
		data() {
			return {
				isExpanded: false,
				promotionSlickOptions: {
					// dots: false,
					// infinite: true,
					// mobileFirst: true,
					// slidesToScroll: 1,
					// slidesToShow: 3,
					// navigation: true,
					// centerMode: true
					dots: false,
					infinite: true,
					mobileFirst: true,
					slidesToScroll: 1,
					slidesToShow: 3,
					navigation: true,
					variableWidth: false,
					centerMode: true,
					autoplay: true,
          autoplaySpeed: 1000,
          centerPadding: '10px',
				},
			};
		},
		methods: {
			togglePromotionContent() {
				this.isExpanded = !this.isExpanded;
			},
			onPromotionImageClick(imageId) {
				this.$router.push("/promotion/" + imageId);
			}
		},
		mounted: function () {
			this.$nextTick(function () {
				setTimeout(() => {
					this.isExpanded = true;
				}, 500);
			});
		}
	};
</script>
